import React, { useEffect, useRef } from "react";
import TaxCalculator from "../components/TaxCalculator";
import { toHashPath } from "../routes/hashRouting";

/* ── STYLED DATA COMPONENTS ────────────────────────────────────────── */
function StaticComparisonTable() {
  return (
    <section className="section" style={{ background: '#f8fafc' }}>
      <div className="container">
         <div className="section-head">
            <div className="h2">Quick Comparison FY 2026-27</div>
            <p className="muted">Standard slabs for individuals below 60 years.</p>
         </div>
         <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: 'var(--shadow)' }}>
            <thead style={{ background: 'var(--accent)', color: '#fff' }}>
               <tr>
                  <th style={{ padding: '15px' }}>Income Slab</th>
                  <th style={{ padding: '15px' }}>Old Regime Rate</th>
                  <th style={{ padding: '15px' }}>New Regime Rate</th>
               </tr>
            </thead>
            <tbody style={{ textAlign: 'center', fontSize: '14px' }}>
               <tr style={{ borderBottom: '1px solid #eee' }}><td style={{ padding: '12px' }}>Up to ₹2.5L / ₹4L</td><td style={{ padding: '12px' }}>Nil</td><td style={{ padding: '12px' }}>Nil</td></tr>
               <tr style={{ borderBottom: '1px solid #eee' }}><td style={{ padding: '12px' }}>₹2.5L to ₹5L / ₹4L to ₹8L</td><td style={{ padding: '12px' }}>5%</td><td style={{ padding: '12px' }}>5%</td></tr>
               <tr style={{ borderBottom: '1px solid #eee' }}><td style={{ padding: '12px' }}>₹5L to ₹10L / ₹8L to ₹12L</td><td style={{ padding: '12px' }}>20%</td><td style={{ padding: '12px' }}>10% - 15%</td></tr>
               <tr style={{ borderBottom: '2px solid var(--accent)' }}><td style={{ padding: '12px' }}>Above ₹10L / ₹20L</td><td style={{ padding: '12px' }}>30%</td><td style={{ padding: '12px' }}>25%</td></tr>
            </tbody>
         </table>
      </div>
    </section>
  );
}

function TaxTipsPanel() {
  return (
    <section className="section">
      <div className="container">
         <div className="section-head">
            <div className="h2">💡 Smart Tax Saving Tips</div>
         </div>
         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
            <div className="card card-pad" style={{ background: '#eff6ff' }}>
               <strong>Section 80C</strong>
               <p style={{ fontSize: '13px' }}>Invest ₹1.5L in ELSS or PPF to save up to ₹45,000 in tax (Old Regime).</p>
            </div>
            <div className="card card-pad" style={{ background: '#ecfdf5' }}>
               <strong>Medical Insurance</strong>
               <p style={{ fontSize: '13px' }}>Deduct up to ₹75,000 under Sec 80D for family and parents.</p>
            </div>
            <div className="card card-pad" style={{ background: '#fef2f2' }}>
               <strong>80CCD (1B)</strong>
               <p style={{ fontSize: '13px' }}>Extra ₹50,000 deduction for NPS investments beyond 80C.</p>
            </div>
         </div>
      </div>
    </section>
  );
}

/* ── MAIN HOMEPAGE ─────────────────────────────────────────────────── */
export default function HomePage({ section }) {
  const calcRef = useRef(null);
  const isStandalone = window.location.hostname.startsWith("tool.") || window.location.hostname.startsWith("tools.") || window.location.hostname.includes(".tool.") || window.location.hostname.includes(".tools.") || new URLSearchParams(window.location.search).get("standalone") === "true";

  useEffect(() => {
    if (section === "calculator" && calcRef.current) {
       calcRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [section]);

  if (isStandalone) {
    return (
      <div className="standalone-tool-wrapper">
        <section className="hero" style={{ padding: '20px 0 10px 0' }}>
          <div className="container">
             <div className="hero-badge" style={{ fontSize: '10px' }}>FY 2026-27 UPDATED</div>
             <h1 className="h1" style={{ fontSize: '28px' }}>India's Most Trusted <span style={{ color: 'var(--accent)' }}>Tax Calculator</span></h1>
          </div>
        </section>

        <section className="section" style={{ paddingTop: '0' }}>
          <div className="container">
             <div className="section-head" style={{ marginBottom: '15px' }}>
                <div className="h2" style={{ fontSize: '22px' }}>Calculate Your Liability</div>
                <p className="muted" style={{ fontSize: '13px' }}>Estimate your tax and find the best regime in simple steps.</p>
             </div>
             <TaxCalculator />
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="site-wrapper">
      <div className="site-main-with-ads">
        <div className="ad-gutter ad-gutter-left">
           <div className="ad-slot ad-slot-skyscraper">160x600</div>
        </div>

        <div className="main-content-area">
          {/* HERO - Ultra Compact */}
          <section className="hero" style={{ paddingBottom: '0' }}>
            <div className="container">
               <div className="hero-badge" style={{ fontSize: '10px' }}>FY 2026-27 UPDATED</div>
               <h1 className="h1" style={{ fontSize: '28px' }}>India's Most Trusted <span style={{ color: 'var(--accent)' }}>Tax Calculator</span></h1>
            </div>
          </section>

          {/* CALCULATOR - MOVED UP */}
          <section className="section" ref={calcRef} style={{ paddingTop: '10px' }}>
            <div className="container">
               <div className="section-head" style={{ marginBottom: '15px' }}>
                  <div className="h2" style={{ fontSize: '22px' }}>Calculate Your Liability</div>
                  <p className="muted" style={{ fontSize: '13px' }}>Estimate your tax and find the best regime in simple steps.</p>
               </div>
               <TaxCalculator />
            </div>
          </section>

          {/* STATIC COMPARISON & TIPS - New Requirement */}
          <StaticComparisonTable />
          <TaxTipsPanel />

          {/* EXPERT GUIDES SECTION */}
          <section className="section" style={{ background: '#f8fafc', padding: '40px 0' }}>
             <div className="container">
                <div className="section-head"><div className="h2">Expert Tax Guides</div></div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                   <div className="card card-pad" style={{ background: '#fff' }}>
                      <strong>💸 Tax Saving Tips 2025</strong>
                      <p style={{ fontSize: '13px', margin: '10px 0' }}>How to max out 80C and 80D with smart investments.</p>
                      <a href={toHashPath("/guides")} style={{ color: 'var(--accent)', fontWeight: 800 }}>Read More →</a>
                   </div>
                   <div className="card card-pad" style={{ background: '#fff' }}>
                      <strong>🏘️ HRA Exemption Guide</strong>
                      <p style={{ fontSize: '13px', margin: '10px 0' }}>Rules for claiming rent exemption and needed proofs.</p>
                      <a href={toHashPath("/guides")} style={{ color: 'var(--accent)', fontWeight: 800 }}>Read More →</a>
                   </div>
                </div>
             </div>
          </section>

          {/* NOT SURE WHICH REGIME - Moved Down */}
          <section className="section">
             <div className="container">
                <div className="card card-pad" style={{ background: 'var(--accent-soft)', border: '2px dashed var(--accent)', textAlign: 'center' }}>
                   <div className="h2" style={{ fontSize: '22px', marginBottom: '10px' }}>⚠️ Not sure which Regime to choose?</div>
                   <p style={{ fontSize: '14px' }}>
                      In FY 2026-27, the New Regime is typically better for salaries up to ₹12L. 
                      However, if you have high home loan interest or HRA, always use our calculator to verify.
                   </p>
                </div>
             </div>
          </section>

          {/* FAQ */}
          <section className="section" style={{ background: '#fff' }}>
            <div className="container">
               <div className="notice" style={{ padding: '20px', fontSize: '12px' }}>
                  <strong>Disclaimer:</strong> This is an indicative report. Tax laws are subject to change. Always consult a qualified CA before filing.
               </div>
            </div>
          </section>
        </div>

        <div className="ad-gutter ad-gutter-right">
           <div className="ad-slot ad-slot-skyscraper">160x600</div>
        </div>
      </div>
    </div>
  );
}
